import { environment } from '../environments/environment';

// Where an Azure resource can be looked at in the portal, for example ['Microsoft.Insights', 'components', 'appi-x'].
export function portalResourceUrl(
  subscriptionId: string,
  resourceGroup: string,
  resource: string[],
): string {
  const segment = encodeURIComponent;
  const id =
    `subscriptions/${segment(subscriptionId)}/resourceGroups/${segment(resourceGroup)}` +
    `/providers/${resource.map(segment).join('/')}`;
  return `https://portal.azure.com/#@${environment.auth.tenantId}/resource/${id}/overview`;
}
